import * as React from "react";
import { SVGProps } from "react";
export const ThumbDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.83335 0.833313L15 0.833314L15 11.6666L9.16669 17.5L8.12502 16.4583C8.0278 16.3611 7.94794 16.2291 7.88544 16.0625C7.82294 15.8958 7.79169 15.7361 7.79169 15.5833V15.2916L8.70835 11.6666L3.33335 11.6666C2.88891 11.6666 2.50002 11.5 2.16669 11.1666C1.83335 10.8333 1.66669 10.4444 1.66669 9.99998L1.66669 8.33331C1.66669 8.23609 1.68058 8.13192 1.70835 8.02081C1.73613 7.9097 1.76391 7.80553 1.79169 7.70831L4.29169 1.83331C4.41669 1.55554 4.62502 1.31942 4.91669 1.12498C5.20835 0.930535 5.51391 0.833313 5.83335 0.833313ZM13.3334 2.49998L5.83335 2.49998L3.33335 8.33331L3.33335 9.99998L10.8334 9.99998L9.70835 14.5833L13.3334 10.9583L13.3334 2.49998ZM15 11.6666V9.99998H17.5L17.5 2.49998L15 2.49998L15 0.833314L19.1667 0.833314L19.1667 11.6666L15 11.6666Z"
            fill="currentColor"
        />
    </svg>
);
ThumbDownIcon.displayName = "ThumbDownIcon";
